import { Timestamp } from "firebase/firestore";

function getCurrentTimeSecondsAndNanoseconds(): { seconds: number; nanoseconds: number } {
  const now = Date.now(); // current time in milliseconds since epoch  
  const seconds = Math.floor(now / 1000);
  const millisecondsPart = now % 1000;
  const nanoseconds = millisecondsPart * 1_000_000;
  return { seconds, nanoseconds };
}

function getCurrentTimestamp(): string {
  const { seconds, nanoseconds } = getCurrentTimeSecondsAndNanoseconds();

  // Convert seconds to date
  const date = new Date(seconds * 1000);

  // Format date to ISO string
  const isoString = date.toISOString().replace('Z', '');

  // Append nanoseconds
  const timestampWithNano = `${isoString}.${nanoseconds.toString().padStart(9, '0')}Z`;

  return timestampWithNano;
}

export function getCurrentTimeStamp(): Timestamp {
  const { seconds, nanoseconds } = getCurrentTimeSecondsAndNanoseconds(); 

  return new Timestamp(seconds,nanoseconds);
}
export function convertProxyToObject<T>(proxyObject: T): T {
  // Serializes the proxy into a JSON string, then parses it back into a plain object.
  return JSON.parse(JSON.stringify(proxyObject)) as T;
}
